import { render, staticRenderFns } from "./ServicesModal.vue?vue&type=template&id=b74b2db6&scoped=true"
import script from "./ServicesModal.vue?vue&type=script&lang=js"
export * from "./ServicesModal.vue?vue&type=script&lang=js"
import style0 from "./ServicesModal.vue?vue&type=style&index=0&id=b74b2db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74b2db6",
  null
  
)

export default component.exports